export default __webpack_public_path__ + "static/media/undo.3e390281.svg";